import * as CustomWidgetFieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { UNIVERSAL_THEME_EDITING_APPS } from '../constants';
const EMPTY_LIST = [];
const EMPTY_MAP = {};
export const getSettingsValuesWithDefaults = (fields, settingsValues, parentFieldKey = EMPTY_LIST) => {
  return fields.reduce((finalMap, field) => {
    const fieldName = field.name;
    const fieldType = field.type;
    const fieldDefault = field.default;
    let fieldValue = settingsValues[fieldName];
    if (fieldType === CustomWidgetFieldTypes.GROUP) {
      fieldValue = getSettingsValuesWithDefaults(field.children, settingsValues, [...parentFieldKey, fieldName]);
    }
    finalMap[fieldName] = fieldValue || fieldDefault;
    return finalMap;
  }, EMPTY_MAP);
};
export const getIsUniversalThemeEditing = fromAppName => {
  return fromAppName && Object.values(UNIVERSAL_THEME_EDITING_APPS).includes(fromAppName);
};